import React, { useCallback, useContext } from "react";
import { AdminListContext } from "../../../../provider/AdminListProvider";
import { InputCheckBox } from "../../../common/input/InputCheckBox";
import { InputTextBox } from "../../../common/input/InputTextBox";

export const AdminListFilter = React.memo(function AdminListFilter() {
    const {
        hideDataSyncFinished,
        setHideDataSyncFinished,
        searchKeyword,
        setSearchKeyword
    } = useContext(AdminListContext);

    const handleHideDataSyncFinishedButtonClicked = useCallback(() => setHideDataSyncFinished(!hideDataSyncFinished), [hideDataSyncFinished, setHideDataSyncFinished]);

    return (
        <div className={"search_option_area"}>
            {/* 利用終了者除外用のチェックボックス */}
            <InputCheckBox label={"利用終了者は除く"} checked={hideDataSyncFinished} handleCheckBoxChanged={handleHideDataSyncFinishedButtonClicked} />
            <InputTextBox value={searchKeyword} handleTextChanged={setSearchKeyword} placeholder={"ハウスID/利用者名/ユーザー名/メールアドレスで検索"}/>
        </div>
    );
});
